import axios from "axios";

export default {
    get: axios.get,
    put: axios.put,
    post: axios.post,
    delete: axios.delete
};
